import { ReactNode } from 'react'
import {
  Header,
  HeaderActions,
  HeaderBreadcrumbs,
  HeaderTitle
} from '@jana-technology/platform-ui'
import FullWidthLayoutContainer from 'common/components/FullWidthLayoutContainer'

interface RiskViewShellProps {
  breadcrumbs: ReactNode
  title: ReactNode
  titleSuffix?: ReactNode
  actions?: ReactNode
  toolbar?: ReactNode
  children: ReactNode
}

const RiskViewShell = ({
  breadcrumbs,
  title,
  titleSuffix,
  actions,
  toolbar,
  children
}: RiskViewShellProps) => {
  return (
    <div className='flex flex-1 flex-col overflow-auto'>
      <Header>
        <FullWidthLayoutContainer className='flex'>
          <div>
            <HeaderBreadcrumbs className='ml-0'>
              {breadcrumbs}
            </HeaderBreadcrumbs>
            <div className='flex items-center'>
              <HeaderTitle>{title}</HeaderTitle>
              {titleSuffix}
            </div>
          </div>
          {actions && <HeaderActions>{actions}</HeaderActions>}
        </FullWidthLayoutContainer>
      </Header>
      {toolbar}
      {children}
    </div>
  )
}

export default RiskViewShell
